import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import {Block, Tabs} from "reakit";
import {Box, Card} from "rebass";
import {LeavesCard} from "../Cards";
import {TabHeader} from "../Base";

const Wrapper = styled(Box)`
	height: 60vh;
  overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
`;


const HOST_PENDING = [0, 4, 5, 6, 7, 8, 9];
const PARENT_PENDING = [0, 4, 5];
const PARENT_HISTORY = [1, 2, 3, 7, 11, 12];
const HOST_HISTORY = [1, 2, 3, 10, 11, 12];



const Leaves = props => {
	const {student} = props;


	return (
		<Box width={1}>
			<Tabs.Container>
				{tabs => (
					<Block>

						<Tabs>

							<Tabs.Tab tab="pending" {...tabs}><TabHeader title={'Pending'}/></Tabs.Tab>
							<Tabs.Tab tab="leaving" {...tabs}><TabHeader title={'History'}/></Tabs.Tab>
						</Tabs>
						<Tabs.Panel tab="pending" {...tabs}>
							<Card mt={'28px'} boxShadow={['none', 'main']} p={2}>
								<Wrapper>
									{student.leaves.filter(leave => leave.parent_host ? PARENT_PENDING.includes(leave.status) : HOST_PENDING.includes(leave.status)).map(leave =>
										<LeavesCard
											key={leave.id} details={leave} hideName/>)}

								</Wrapper>
							</Card>
						</Tabs.Panel>
						<Tabs.Panel tab="leaving" {...tabs}>
							<Card mt={'28px'} boxShadow={['none', 'main']} p={2}>
								<Wrapper>
									{student.leaves.filter(leave => leave.parent_host ? PARENT_HISTORY.includes(leave.status) : HOST_HISTORY.includes(leave.status)).map(leave =>
										<LeavesCard hideName key={leave.id}
										            details={leave}/>).reverse()}
								</Wrapper>
							</Card>
						</Tabs.Panel>

					</Block>
				)}
			</Tabs.Container>
		</Box>
	);
};

Leaves.propTypes = {
	student: PropTypes.object
};

export default Leaves;
